import { render, staticRenderFns } from "./NewOrder.vue?vue&type=template&id=42c3ac7c&scoped=true"
import script from "./NewOrder.vue?vue&type=script&lang=js"
export * from "./NewOrder.vue?vue&type=script&lang=js"
import style0 from "./NewOrder.vue?vue&type=style&index=0&id=42c3ac7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c3ac7c",
  null
  
)

export default component.exports